<section class="modal-content" [class.modal-content-right]="showModalOnRight">
  <section class="flex flex-column">
    <div class="header-content mx-6 pt-6">    
      <h5>Payment Verification</h5>
    </div>

    <div class="body-content py-8 px-6">
      <div class="w-10/12 mx-auto flex flex-col gap-3.5">
        <p class="font-italic">
          I understand that upon signing here means that I confirm that the service has been completed by the assigned filed employee and
          that this work order is hereby ready for invoicing.
        </p>
  
        <div
          #signContainer
          *ngIf="activeForm === CustForm"
          class="signature"
        >
          <label class="font-medium mb-2">Customer Signature</label>
          <div class="signature-wrap">
            <ng-container *ngIf="isShow">
              <signature-pad
                #SignaturePad
                [options]="signaturePadOptions"
                (onBeginEvent)="drawStart()"
                (onEndEvent)="drawComplete()"
              ></signature-pad>
  
              <span *ngIf="signatureExists" class="signature-clear" (click)="clearSign()">Clear</span>
            </ng-container>
          </div>
        </div>

        <form *ngIf="activeForm === EmpForm">
          <cj-form-field class="w-full">
            <cj-form-label>Password</cj-form-label>
            <input
              cjInput
              fullWidth
              type="password"
              size="large"
              autocomplete="off"
              placeholder="&bull;&bull;&bull;&bull;&bull;&bull;"
              [(ngModel)]="password"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isLoading"
              (keyup.enter)="verifyPassword()"
            />
          </cj-form-field>
        </form>

        <button
          *ngIf="!hideUserPassword"
          cjButton
          type="button"
          class="!bg-blue-10 !text-blue-90 !border-blue-10 self-center"
          [disabled]="isLoading"
          (click)="toggleActiveForm()"
        >
          <span *ngIf="activeForm === CustForm" class="mr-2">
            <cj-icon icon="key" pack="font-awesome-solid"></cj-icon>
          </span>
          <span *ngIf="activeForm === EmpForm" class="mr-2">
            <cj-icon icon="signature" pack="font-awesome-solid"></cj-icon>
          </span>
          {{ activeForm === CustForm ? 'Enter employee password' : 'Customer signature' }}
        </button>
      </div>
    </div>

    <div class="footer-content flex justify-end mx-6 pb-6">
      <button
        cjButton
        type="submit"
        size="large"
        [disabled]="isLoading"
        (click)="verifyAction()"
      >
        <span *ngIf="isLoading" class="mr-2">
          <cj-icon class="fa-spin" icon="spinner" pack="font-awesome-solid"></cj-icon>
        </span>
        {{ !isLoading ? 'Verify' : 'Verifying...' }}
      </button>
    </div>
  </section>
</section>